/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateComponentClassRequestDto
 */
export interface CreateComponentClassRequestDto {
    /**
     * Unique code for the component class
     * @type {string}
     * @memberof CreateComponentClassRequestDto
     */
    code: string;
    /**
     * Name of the component class
     * @type {string}
     * @memberof CreateComponentClassRequestDto
     */
    name: string;
    /**
     * Description of the component class
     * @type {string}
     * @memberof CreateComponentClassRequestDto
     */
    description?: string;
    /**
     * List of synonyms for this component class
     * @type {Array<string>}
     * @memberof CreateComponentClassRequestDto
     */
    synonyms?: Array<string>;
    /**
     * Parent component class ID for hierarchy
     * @type {string}
     * @memberof CreateComponentClassRequestDto
     */
    parentId?: string;
    /**
     * Parent component class code as alternative to parentId
     * @type {string}
     * @memberof CreateComponentClassRequestDto
     */
    parentCode?: string;
}

/**
 * Check if a given object implements the CreateComponentClassRequestDto interface.
 */
export function instanceOfCreateComponentClassRequestDto(value: object): value is CreateComponentClassRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateComponentClassRequestDtoFromJSON(json: any): CreateComponentClassRequestDto {
    return CreateComponentClassRequestDtoFromJSONTyped(json, false);
}

export function CreateComponentClassRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateComponentClassRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'synonyms': json['synonyms'] == null ? undefined : json['synonyms'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'parentCode': json['parentCode'] == null ? undefined : json['parentCode'],
    };
}

export function CreateComponentClassRequestDtoToJSON(json: any): CreateComponentClassRequestDto {
    return CreateComponentClassRequestDtoToJSONTyped(json, false);
}

export function CreateComponentClassRequestDtoToJSONTyped(value?: CreateComponentClassRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'synonyms': value['synonyms'],
        'parentId': value['parentId'],
        'parentCode': value['parentCode'],
    };
}

